export default __webpack_public_path__ + "static/media/Destination_Icon.4c366dc6.svg";